// extracted by mini-css-extract-plugin
export var PhoneAndLess = "only screen and (max-width: 767px)";
export var header = "header-module--header--3bd0c";
export var logo = "header-module--logo--e2cb9";